export const bookingMetadataTypes = {
  inputMeetingData: "input_meeting_data",
} as const;
